module.exports = __webpack_public_path__ + "static/media/STAF_bokmål og sørsamisk_primærlogo_pos(svart).3482f001.png";